<script setup lang="ts">
import type { ITag } from '~/shared/interfaces/ui/tags';

const props = defineProps<{
  tag: ITag,
}>();

const {
  tagType,
  tagColor,
  isActive,
  hasAction,
  text,
  icon,
  iconBeforeText,
  size,
} = props.tag;

</script>

<template>
  <div class="tag" :class="[
    tagType,
    tagColor,
    size,
    isActive && 'active',
    hasAction && 'pointer',
    iconBeforeText && 'reverse',
  ]">
    <span class="tag-text">{{ text }}</span>
    <div v-if="icon" v-html="icon" class="tag-icon">
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tag {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 2px 6px;
  border-radius: 100px;
  background: $bg_light-grey;
  width: fit-content;
  @include font(12px, 16px, 500);

  &.reverse {
    flex-direction: row-reverse;
  }

  &.pointer {
    cursor: pointer;
  }

  &.red {
    background: $control-content_negative;
  }

  &.green {
    background: $content_success;
    color: $content_white;
  }

  &.light-green {
    background: #E1F9EA;
  }

  &.light-yellow {
    background: $bg_warning;
  }

  &.yellow {
    background: $colors_yellow;
  }

  &.purple {
    background: $colors_purple;
  }

  &.black,
  &.active {
    background: $bg_black;
  }

  &.gray {
    color: $content_primary;
    background: $control-bg_neutral;
  }

  &.dark-gray {
    background: $control-bg_inverse-disabled;
  }

  &.white {
    background: $content_white;
  }

  &.black,
  &.active,
  &.purple,
  &.yellow {
    color: $content_white;
  }

  &.round {
    padding: 11px 12px;
    border-radius: 20px;

    &.small {
      padding: 2px 8px;
      border-radius: 40px;
      gap: 2px;
      @include font(14px, 20px, 400);
    }
  }

  &.small {
    @include font(12px, 14px, 500);
  }

  &-icon {
    display: flex;
    align-items: center;
    width: 16px;
    height: 16px;
  }
}
</style>
